﻿import { defineComponent } from 'vue';
import { response_booking } from "../../../tms/booking_engine/objects/v1_3/booking/search/response_booking";
import { Booking } from "../../booking_engine/services/booking";
import { Date_Service } from "../../system/services/date_service";

let Book: Booking = new Booking();
let Date_Services: Date_Service = new Date_Service();

type SortKey = 'departure' | 'id' | 'reference' | 'lead' | 'booking' | 'consultant' | 'status' | 'trip';

export default defineComponent({
  name: 'booking_cards',
  props: {
    bookings: {
      type: Array as () => response_booking[] | undefined,
      required: false
    }
  },
  data() {
    return {
      sortKey: 'departure' as SortKey,
      sortAsc: true,
      searching: false,
      namesExpandedAll: false,
      loadingIndex: -1
    }
  },
  methods: {
    Lead_Passenger(b: response_booking): string {
      const p = b?.passengers?.[0];
      return (p?.first_name ?? "") + " " + (p?.family_name ?? "");
    },
    Trip_Name(b: response_booking): string {
      return b?.trips?.[0]?.trip_name ?? "";
    },
    Short_Trip_Name(b: response_booking, maxLen = 24): string {
      const full = this.Trip_Name(b);
      return full.length <= maxLen ? full : full.slice(0, maxLen - 1) + '…';
    },
    Toggle_Names_All() {
      this.namesExpandedAll = !this.namesExpandedAll;
    },
    Display_Trip_Name(b: response_booking, maxLen = 24): string {
      return this.namesExpandedAll ? this.Trip_Name(b) : this.Short_Trip_Name(b, maxLen);
    },
    Departure_Date_Display(b: response_booking): string {
      return Date_Services.display_date(b?.trips?.[0]?.departure_date ?? "");
    },
    Booking_Date_Display(b: response_booking): string {
      return Date_Services.display_date(b?.trips?.[0]?.booking_date ?? "");
    },
    Booking_ID(b: response_booking): string {
      return String((b as any)?.group_booking_id ?? (b as any)?.id ?? "");
    },
    Agent_Reference(b: response_booking): string {
      return (b as any)?.agent_reference ?? "";
    },
    Get_Consultant(b: response_booking): string {
      return b?.trips?.[0]?.affiliate_contact ?? "";
    },
    Booking_Status(b: response_booking): string {
      return b?.trips?.[0]?.passengers?.[0]?.status ?? "";
    },
    setSort(key: SortKey) {
      if (this.sortKey === key) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
        this.sortAsc = true;
      }
    },
    valueForSort(b: response_booking): string | number {
      switch (this.sortKey) {
        case 'lead':        return this.Lead_Passenger(b).toLowerCase();
        case 'id':          return this.Booking_ID(b).toLowerCase();
        case 'reference':   return this.Agent_Reference(b).toLowerCase();
        case 'consultant':  return this.Get_Consultant(b).toLowerCase();
        case 'status':      return this.Booking_Status(b).toLowerCase();
        case 'trip':        return this.Trip_Name(b).toLowerCase();
        case 'departure': {
          const d = b?.trips?.[0]?.departure_date ?? "";
          const t = d ? new Date(d).getTime() : 0;
          return isNaN(t) ? 0 : t;
        }
        case 'booking': {
          const d = b?.trips?.[0]?.booking_date ?? "";
          const t = d ? new Date(d).getTime() : 0;
          return isNaN(t) ? 0 : t;
        }
        default: return 0;
      }
    },
    async Booking_Details(b: response_booking, index: number) {
      const id = (b as any)?.group_booking_id ?? (b as any)?.id;
      if (!id) {
        return;
      }
      this.loadingIndex = index;
      try {
        const details = await Book.Get_Book(id, this.$store.getters.get_Agent_Login);
        this.$store.commit("Setup_Booking", { Booking_Details: details });
        this.$store.commit("Initialise_Booking_Cancellation");
        this.$router.push("/search/details");
      } finally {
        this.loadingIndex = -1;
      }
    },
    Row_Key(b: response_booking, index: number): string {
      return this.Booking_ID(b) || index.toString();
    }
  },
  computed: {
    Sorted_Bookings(): response_booking[] {
      const list = (this.bookings ?? []).slice();
      const asc = this.sortAsc ? 1 : -1;
      list.sort((a, b) => {
        const va = this.valueForSort(a);
        const vb = this.valueForSort(b);
        if (va < vb) { return -1 * asc; }
        if (va > vb) { return  1 * asc; }
        return 0;
      });
      return list;
    }
  }
});
